import React from 'react';
/** Link nativo para o início absoluto da página atual, sem trocar de rota. */
export default function BackToTop({pageId}) {
 const target='topo-'+pageId;
 function scrollToStart(event){
  event.preventDefault();
  const anchor=document.getElementById(target);
  if(!anchor)return;
  anchor.scrollIntoView({block:'start',inline:'nearest',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 }
 return <div className="back-to-page-start"><a href={'#'+target} onClick={scrollToStart}>↑ VOLTAR AO TOPO</a></div>;
}
